import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded component
const Main = Loadable(lazy(() => import("../Main")));

const dynamicDocumentRoute = [
  {
    path: "dynamic-document",
    children: [
      {
        path: "manage",
        element: <Main />
      }
    ]
  }
];

export default dynamicDocumentRoute;
